export const URL = '/api';
// export const URL = 'https://v1.sosiago.id/api';
//export const URL='https://api.stg.sosiago.id/api';


// WEBPACK FOOTER //
// ./src/actions/api.js